<template>
  <v-footer class="amber darken-2">
    <v-card class="flex" flat tile>
      <v-card-actions class="justify-center">
        <!-- <a href="https://alexhooley.com"> -->
          EHTkollen är skapad för yrkesprofesionella inom skolhälsan av EHTkollen.se 2022
        <!-- </a> -->
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>

export default {
  name: 'appFooter'
}
</script>
